module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "px-3 mb-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "persistent-hint": "",
      "clearable": "",
      "label": "Password",
      "hint": "The password your client needs to use to access this invoice"
    },
    model: {
      value: (_vm.localpassword),
      callback: function($$v) {
        _vm.localpassword = $$v
      },
      expression: "localpassword"
    }
  }), _vm._v(" "), (_vm.relIdNumber) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.localpassword = _vm.relIdNumber;
        _vm.localpasswordHint = "Use your ID number to unlock the pdf"
      }
    }
  }, [_vm._v(_vm._s(_vm.relIdNumber))]) : _vm._e(), _vm._v(" "), (_vm.relEmail) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.localpassword = _vm.relEmail;
        _vm.localpasswordHint = "Use your email address to unlock the pdf"
      }
    }
  }, [_vm._v(_vm._s(_vm.relEmail))]) : _vm._e(), _vm._v(" "), (_vm.relPhone) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.localpassword = _vm.relPhone;
        _vm.localpasswordHint = "Use your 12 digit phone number starting with + to unlock the pdf"
      }
    }
  }, [_vm._v(_vm._s(_vm.relPhone))]) : _vm._e()], 1), _vm._v(" "), (_vm.localpassword) ? [_c('v-flex', [_c('v-text-field', {
    staticClass: "caption",
    attrs: {
      "persistent-hint": "",
      "clearable": "",
      "label": "Password hint",
      "hint": "You can add a hint to help your client know what password to use"
    },
    model: {
      value: (_vm.localpasswordHint),
      callback: function($$v) {
        _vm.localpasswordHint = $$v
      },
      expression: "localpasswordHint"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "amber lighten-3 pa-1 mt-2"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Encrypted PDFs may effect the delivery of your emails\n      ")], 1)])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43cdcecb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/manage/create/encrypt.vue
// module id = 1408
// module chunks = 9